// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThreeDCard_wrapper__3WkJN"};